import { InputFieldEnum } from '@/features/ui/inputs/components/InputField/constants'
import { useState } from 'react'

export const useEnabledInputFieldState = () => {
    const [isHovered, setIsHovered] = useState(false)
    const [isFocused, setIsFocused] = useState(false)

    const getState = () => {
        if (isFocused) return InputFieldEnum.Focused

        if (isHovered) return InputFieldEnum.Hovered

        return InputFieldEnum.Default
    }

    const handleMouseEnter = () => setIsHovered(true)
    const handleMouseLeave = () => setIsHovered(false)
    const handleFocus = () => setIsFocused(true)
    const handleBlur = () => setIsFocused(false)

    return {
        state: getState(),
        eventHandlers: {
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleFocus,
            onBlur: handleBlur,
        },
    } as const
}
